export default __webpack_public_path__ + "static/media/SoundCloudLogo.2d8b58f8.svg";